import React from "react";
import { useState } from "react";
import { Chart } from "react-google-charts";
import { DataContext } from '../App';

const {getPadding, average, min, max} = require('../utils.js');

function DailyChart(props) {

    const forecast = React.useContext(DataContext);

    const [dataRange, setDataRange] = useState(365);

    var timestamp = forecast.premium[props.field].timestamp
    var values = forecast.premium[props.field].data

    var chart_data = [["Date", "Value"]]
    for (let i = 0; i < values.length; i++) {

        var d = new Date(1000*timestamp[i]);

        var YYYY = d.getFullYear();
        var MM = d.getMonth();
        var DD = d.getDate();

        var item = [new Date(YYYY, MM, DD), values[i]]
        chart_data.push(item)
    }

    const nPoints = chart_data.length

    var chart_data_ranged = [["Date", "Value"]].concat(chart_data.slice(nPoints-dataRange,nPoints))

    const options = {
        //chartArea: { height: "100%", width: "90%" },
        chartArea:{left:'5%',top:'15%', bottom:'15%', right:'5%', width:'100%',height:'70%'},
        hAxis: { slantedText: false },
        vAxis: { viewWindow: { min: 0, max: max(values)*1.1 } },
        legend: { position: "none" },
        colors: ["#282880"],
        curveType: "function"
      };

  return (
    <div>
        <div className="card-body">
            <div className="row">
                <div className="col-lg-8"></div>
                <div className="col-lg-4">
                    <button type="button" id="1Y" className="btn btn-xs rounded btn-outline-dark mr-1 ml-1 mb-1" onClick={() => setDataRange(365)}>1Y</button>
                    <button type="button" id="6M" className="btn btn-xs rounded btn-outline-dark mr-1 ml-1 mb-1" onClick={() => setDataRange(6*30)}>6M</button>
                    <button type="button" id="1M" className="btn btn-xs rounded btn-outline-dark mr-1 ml-1 mb-1" onClick={() => setDataRange(3*30)}>3M</button>
                    <button type="button" id="3M" className="btn btn-xs rounded btn-outline-dark mr-1 ml-1 mb-1" onClick={() => setDataRange(1*30)}>1M</button>
                </div> 
            </div>  
            <div style={{height:"180px"}}>
                <Chart
                    chartType={props.type}
                    width="100%"
                    //height="100px"
                    data={chart_data_ranged}
                    options={options}
                    chartPackages={["corechart", "controls"]}
                />
            </div>
        </div> 
    </div>
    
  );
}

export default DailyChart;
